// Bus.js
import Vue from 'vue'
const Bus = new Vue()
export default Bus



// WEBPACK FOOTER //
// ./src/utils/Bus.js